import ImageWithBasePath from "@/components/image-with-base-path"
import DraggableSlider from "@/components/draggable-slider/DraggableSlider"


const TreatmentSection = () => {
  return (
   <>
  {/* Treatment Section */}
  <section className="treatment-section section">
    <div className="container">
      <h2>
        Advanced Dermatology Treatments{" "}
        <span className="care-img bg-primary">
          <ImageWithBasePath
            src="assets/img/bg/skincare-01.png"
            alt="skin care"
            className="img-fluid"
          />
        </span>{" "}
        <span className="text-secondary">Enhanced</span>
        <span className="care-img bg-secondary">
          <ImageWithBasePath
            src="assets/img/bg/skincare-02.png"
            alt="skin care"
            className="img-fluid"
          />
        </span>{" "}
        <span className="text-secondary">Patient Care.</span>
      </h2>
      {/* start row */}
      <div className="row g-4">
        <div className="col-md-6 d-flex">
          <DraggableSlider
            beforeImage="assets/img/about/slide-lg-01.jpg"
            afterImage="assets/img/about/slide-01.jpg"
            alt="treatment"
          />
        </div>
        <div className="col-md-6 d-flex">
          <DraggableSlider
            beforeImage="assets/img/about/slide-lg-02.jpg"
            afterImage="assets/img/about/slide-02.jpg"
            alt="treatment"
          />
        </div>
      </div>
    </div>
  </section>
  {/* Treatment Section End */}
</>

  )
}

export default TreatmentSection